module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('f7-views', [_c('f7-view', {
    attrs: {
      "id": "main-view",
      "navbar-fixed": "",
      "main": ""
    }
  }, [_c('f7-pages'), _vm._v(" "), (!_vm.isMobileAlone && _vm.isAddHomeScreenShow) ? _c('add-to-homescreen-adaptive') : _vm._e(), _vm._v(" "), (!_vm.isMobileAlone && !_vm.isAddHomeScreenShow) ? _c('add-homescreen-button') : _vm._e()], 1)], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": _vm.notificationsGroup,
      "position": "bottom right",
      "max": 3
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5791b66c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5791b66c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/app.vue
// module id = 830
// module chunks = 0